const ko = {
  // 404 ERROR PAGE
  errorTitle: '요청하신 페이지를 찾을 수 없습니다.',
  errorSubTitle: '서비스 이용에 불편을 드려 죄송합니다.',
  errorMsg1: '요청하신 페이지의 주소가 잘못 입력되었거나,',
  errorMsg2: '페이지 주소의 변경 혹은 삭제로 인해 현재 사용하실 수 없습니다.',
  errorMsg3: '입력하신 페이지의 주소가 정확한지 다시 한번 확인 해주시기 바랍니다.',
  back: '홈으로',

  // LOGIN
  id: '아이디',
  pw: '비밀번호',
  login: '로그인',
  autoLogin: '자동로그인',

  // COMMON
  no: '번호',
  search: '검색',
  inquery: '조회',
  excel: '엑셀다운로드',
  plus: '추가',
  save: '저장',
  delete: '삭제',
  print: '출력',
  close: '닫기',
  cancel: '취소',
  confirm: '확인',
  reload: '편집취소',
  camera: '캡처',
  apply: '적용',
  copy: '복사',
  themeGenerator: '테마 설정',
  themeSelect: '테마 선택',
  color: '색상',
  button: '버튼',
  radio: '라디오',
  checkBox: '체크박스',
  selectBox: '선택박스',
  input: '입력',
  dialog: '다이얼로그',
  weldingTab: '용접기',
  cameraTab: '카메라',
  data: '데이터',
  graph: '그래프',
  period: '기간',
  use: '사용',
  unused: '미사용',
  correction: '수정',
  initialization: '비밀번호초기화',

  // COMPONENTS
  icardHorizontal: 'i-Card Horizontal',
  icardVertical: 'i-Card Vertical',
  idataTable: 'i-Data Table',
  iseleltList: 'i-Selelt List',
  idialog: 'i-Dialog',

  // MENU

  // baseInfoManage: '기준정보관리',
  dashboard: '대시보드',
  '대시보드': '대시보드',

  // Base Information

  //card Title
  commonCodeTitle: '■ 공통코드',
  commonCodeDetail: '■ 공통코드 상세',
  companyInfoTitle: '■ 회사정보',
  departmentInfo: '■ 부서정보',
  employeeInfo: '■ 사원정보',
  factoryInfoTitle: '■ 공장정보',
  processInfoTitle: '■ 공정정보',
  warehouseInfoTitle: '■ 창고정보',
  warehouseLocInfoTitle: '■ 창고위치 정보',
  workStationInfo: '■ 작업장 정보',
  workGroupInfo: '■ 작업반 정보',
  equipmentInfo: '■ 설비정보',
  pathInfo: '■ 경로정보',
  customerInfo: '■ 거래처정보',
  itemSelection: '■ 품목선택',
  customer: '■ 거래처',
  itemInfoTitle: '■ 품목정보',
  pathTypeTitle: '■ 경로유형',
  routeInfoTitle: '■ 경로정보',
  bomInfoTitle: '■ BOM정보',
  customerInfoByItemTitle: '■ 품목별 거래처정보',
  unitPriceInfoTitle: '■ 단가정보',
  inspectionType: '■ 검사유형',
  inspectionItems: '■ 검사항목',


  //Data Column

  inspection:'검사유형',

  inspection: '검사유형',

  appStartDate: '단가적용 시작일',
  appEndDate: '단가적용 종료일',
  modiYN: '단가수정여부',
  comName: '회사명',
  corNumber: '법인등록번호',
  comNumber: '사업자등록번호',
  partSpec: '품목 규격',
  name: '대표자명',
  postNo: '우편번호',
  addr: '주소',
  tel: '전화번호',
  fax: '팩스번호',

  depCode: '작업 부서(부서코드)',
  depName: '부서명',
  paDecode: '상위부서코드',
  paDecodeNm: '상위부서',

  userId: '사용자ID',
  userName: '사용자명',
  perCode: '권한그룹 코드',
  typeCode: '사원유형 코드',
  typeCodeNm: '사원유형',
  posiCode: '직위 코드',
  posiCodeNm: '직위',
  hp: '핸드폰',
  email: '이메일',
  entDate: '입사일',
  lanCode: '언어코드',
  userImage: '사원 이미지',

  custCode: '거래처코드',
  custName: '거래처명',
  custType: '거래처유형 코드',
  custTypeNm: '거래처 유형',
  matType: '거래유형 코드',
  matTypeNm: '거래 유형',
  conType: '업태',
  secType: '업종',
  manName: '담당자명',
  manTel: '담당자 연락처',
  manAddr: '담당자 이메일',

  partNo: '품번',
  partName: '품명',
  spec: '규격',
  insName: '검사 유형명',
  itemType: '품목군 코드',
  partType: '제품군 코드',
  suite: '제품군',
  unit: '단위 코드',
  inWh: '입고창고',
  outWh: '출고창고',
  lotSize: '로트크기',
  safeCnt: '안전재고',
  inInsp: '입고검사 유무',
  proInsp: '공정검사 유무',
  rotInsp: '순회검사 유무',
  outInsp: '출하검사 유무',
  lastInsp: '최종검사 유무',
  supInsp: '공급처출하검사여부',
  leadTime: '리드타임(일수)',
  weightYn: '단중사용여부',
  weight: '단중(kg)',
  userDef1: '사용자정의1',
  userDef2: '사용자정의2',
  userDef3: '사용자정의3',

  pathType: '경로유형 코드',
  pathTypeName: '경로유형명',
  pathCode: '경로코드',
  inWhcode: '입고창고 코드',
  inWhName: '입고창고명',
  sortFlag: '정렬순서',

  pathNo: '공정순서',
  proCode: '공정코드',
  proCode_facGrp: '공정코드(설비그룹)',
  matCost: '재료비',
  proCost: '가공비',
  labCost: '노무비',

  level: '레벨',
  paPartNo: '모품번',
  No: '자품목순번',
  childPartNo: '자품번 코드',
  amount: '소진량',

  appDate: '적용일',
  appYN: '단가적용여부',
  price: '단가',
  codeName: '코드명',
  currDate: '일자',
  currCode: '통화코드',
  price2: '기준환율',

  facCode: '공장코드',
  facName: '공장명',
  facNumber: '공장등록번호',
  facRepName: '공장대표자명',

  proName: '공정명',
  proType: '공정구분',
  catType: '공정유형',

  whCode: '창고코드',
  whCode_autoInput: '자동투입창고',
  whName: '창고명',
  whType: '창고구분',
  whDesc: '창고설명',
  locCode: '위치코드',
  locName: '위치명',

  workCode: '작업장 코드',
  workName: '작업장명',
  workType: '작업장 유형',
  workDesc: '작업장 설명',
  workDecode: '작업반 코드',
  workDename: '작업반명',
  workDedesc: '작업반 설명',
  perWh: '실적공정 코드',

  eqCode: '설비코드',
  eqName: '설비명',
  eqSpec: '설비사양',
  eqGrade: '설비등급',
  eqState: '설비상태',
  makeCom: '제작회사',
  perCom: '구입회사',
  proDate: '제조일',
  insDate: '설치일',
  desDate: '폐기일',
  eqpImage: '이미지',

  pathName: '경로명',
  procCode: '공정코드',
  procNo: '공정순서',

  insCode: '검사유형 코드',
  insType: '검사항목 코드',
  insMeth: '측정방법 코드',
  jugCodeh: '판정방법 코드',

  inspNo: '검사순서',
  insUnit: '검사단위 코드',
  insBase: '검사기준',
  insUpp: '상한치',
  insLow: '하한치',
  insCnt: '시료수',

  //tab name
  departmentInfoTab: '부서정보',
  customerInfoTab: '거래처정보',

  //popup
  addCustomerInfo: '거래처정보 추가',
  registrantInfo: '등록자 정보',

  //production Management

  //card Title
  shptReg: '■ 출하등록',
  shptChk: '■ 출하검사(검사결과)',
  returnReg: '■ 반품등록',
  salesCfm: '■ 매출확정',

  //Data Column
  ordNo: '수주번호',
  ilNo: '출하 일련번호',
  outDate: '출하일',
  lotNo: '출하LOT',
  lotDetail: '출하전산번호',
  qty: '수량',
  closeMonth: '마감월',
  closeYn: '마감여부',
  confirmYn: '마감확정여부',
  sampleQty1: '시료1',
  sampleQty2: '시료2',
  sampleQty3: '시료3',
  sampleQty4: '시료4',
  sampleQty5: '시료5',
  retLotNo: '반품 LOT',
  retLotDetail: '반품 전산번호',
  retCode: '반품구분 코드',
  retType: '반품불량사유 코드',
  retQty: '반품수량',

  // System Management

  //card title
  permissionGroupInfo: '권한그룹정보',
  menuList: '메뉴리스트',

  //Add Message
  sys0010AddCheck: '메뉴코드, 모듈코드를 입력해주세요.',
  sys0020AddCheck: '권한그룹(코드)를 입력해주세요.',

  //Data Column
  comCode: '회사코드',
  codegr: '코드그룹',
  code: '코드',
  sysName: '시스템코드 명',
  sysCode: '시스템코드',
  //proCode: '공장코드',
  sysType: '시스템구분',
  menuCode: '메뉴코드',
  moduleCode: '모듈코드',
  moduleName: '모듈명',
  menuName: '메뉴명',
  paCode: '부모메뉴코드',
  pgCode: '프로그램코드',
  icon: '이미지',
  ilno: '일련번호',
  regiDate: '등록일',
  planDate: '계획일',
  planQty: '계획수량',
  prePlanQty: '이전 계획수량',
  remark: '비고',
  userFlag: '사용유무',
  makeDate: '등록일',
  maker: '등록자',
  editDate: '수정일',
  editor: '수정자',
  workDate: '생산일',
  orderState: '작업지시 상태 코드',
  priCode: '우선순위코드',
  workCrew: '작업조 코드',
  orderQty: '지시량',
  planNo: '생산계획 번호',
  workNo: '작업지시번호',
  workDecodeName: '작업반 이름',
  perName: '권한그룹명',
  permissionGroup: '권한그룹(코드)',
  preProCode: '이전 공정 코드',
  preWorkCode: '이전  작업장 코드',
  preWorkDecode: '이전 작업반코드',
  preWhCode: '이전 창고코드',
  nowWhCode: '현재 창고코드',


  //card title(자재관리)
  purchOrdInfo: '■ 구매 발주정보',
  purchOrdInfoDetail: '■ 구매 발주정보 상세',
  purchWarinReg: '■ 구매 입고 등록',
  purchWarinRegDetail: '■ 구매 입고정보 상세',
  otr_PvtSupWarinReg: '■ 기타/사급자재 입고 등록',
  otr_PvtSupWarinDetail: '■ 기타/사급자재 입고 상세',
  matlReqt: '■ 자재소요량(생산계획기준)',
  matlReqtDetail: '■ 자재소요량 상세',
  manualOperReg: '■ 수작업등록',
  excelReg: '■ 엑셀등록',




  //Data Column
  ordState: '발주상태',
  deliDate: '납기일',
  stockQty: '현재고량',
  inQty: '입고량',
  remQty: '잔량',

  makeQty: '구성량',
  boxQty: 'BOX수량',
  inPrice: '입고단가',
  inAmount: '입고금액',
  printType: '라벨출력 구분',
  ilNo_serNo: '입고번호(일련번호)',
  //ilNo:'일련번호', (보류)
  serialNo: '일련번호 순번',
  status: '입고상태',
  fromDate: '산출 시작일',
  toDate: '산출 종료일',
  currQty: '현재고 수량',
  expQty: '미입고 수량',
  reqQty: '소진 수량',
  lackQty: '부족 수량',
  ordQty: '발주 수량',
  ordAppYn: '자재발주 적용 유무',

  realQty: '실사수량',
  realState: '실사상태',
  stockType: '재고유형',
  regiType: '등록구분',







  // Dashboard
  // themeTab: '테마',
  // controlsTab: '컨트롤',
  // gridTab: '그리드',
  // chartsTab: '차트',
  // componentsTab: '컴포넌트', 

  // weldingInfo: '용접 이상 정보',
  // weeklyWelding: '주간 용접 이상 발생량',
  // deviceUtilization: '장비 가동율(시간)',
  // weeklygas: '주간 가스 사용량',

  // Monitoring
  //equipmentSelect: '장비선택',
  //weldingData: '셋팅 정보',
  //statusInfo: '실시간 데이터 정보',
  //weldingImage: '용접이미지',
  //current: '전류',
  //voltage: '전압',
  //gas: '가스',
  //feeding: '피딩',

  // Setting
  //baseGroup: '기준그룹',
  //baseCode: '기준코드',
  //userGroup: '사용자그룹',
  //userList: '사용자목록',

  // Data Search
  //equipmentInfomation: '장비정보',

  // MSG
  //enableCheckbox: '체크박스를 통해 활성/비활성화 하세요.',

  //Common Message
  SelectCheck: '선택된 데이터가 없습니다.',
  doSaveData: '저장 하시겠습니까?',
  doFixData: '수정 하시겠습니까?',
  Saved: '저장 되었습니다.',
  changed: '수정 되었습니다.',
  doDeleteData: '삭제 하시겠습니까?',
  deleted: '삭제 되었습니다.',
  requiredCheck:'필수항목 입력하세요.',

  //부서정보,사원정보,거래처정보 Message
  requiredInput: '회사코드, 부서코드를 입력하세요.',
  requiredInput2: '회사코드, 부서코드, 사용자ID를 입력하세요.',
  requiredInput3: '회사코드, 거래처코드를 입력 해주세요.',
  departmentCodeOverlap: '부서코드가 중복 입니다.',
  userIdOverlap: '사용자 ID가 중복 입니다.',
  accountCodeOverlap: '거래처코드가 중복 입니다.',
  employeesRegistered: '부서에 등록된 사원이 있습니다.',
  resetYourPassword: '비밀번호를 초기화 하시겠습니까?',
  resetPassword: '비밀번호가 초기화 되었습니다.',
  departmentsSelected: '선택된 부서가 없습니다.',

  //공장/창고/작업장/경로정보 Message
  bas0120PleaseCheck1: '공장 정보를 선택해주십시오.',
  bas0120PleaseCheck2: '창고 정보를 선택해 주십시오',
  bas0120PleaseCheck3: '작업장 정보를 선택해주십시오.',
  bas0120PleaseCheck4: '경로 정보를 선택해주십시오.',
  bas0120NotFound1: '창고 코드가 존재하지 않습니다.',
  bas0120NotFound2: '작업장 코드가 존재하지 않습니다.',
  bas0120NotFound3: '경로 코드가 존재하지 않습니다.',

  bas0120RequiredInput1: '필수항목 입력하세요.[회사코드, 공장코드]',
  bas0120RequiredInput2: '필수항목 입력하세요.[공정코드]',
  bas0120RequiredInput3: '필수항목 입력하세요.[창고코드]',
  bas0120RequiredInput4: '필수항목 입력하세요.[창고코드, 위치코드]',
  bas0120RequiredInput5: '필수항목 입력하세요.[작업장코드]',
  bas0120RequiredInput6: '필수항목 입력하세요.[작업장코드, 작업반코드]',
  bas0120RequiredInput7: '필수항목 입력하세요.[설비코드]',
  bas0120RequiredInput8: '필수항목 입력하세요.[경로코드]',
  bas0120RequiredInput9: '필수항목 입력하세요.[경로코드, 공정코드, 공정순서]',

  // POP Title
  itemInfo: '품목정보',
  mainItem: '주요항목'

}
export default ko